module.exports = {
	"concerts_title": {
		"cs-CZ": "Nadcházející Koncerty",
		"en-GB": "Upcoming Concerts",
		"fr-FR": "Concerts à venir",
		"de-DE": "Kommende Konzerte"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home.json
// module id = 82
// module chunks = 0